document.addEventListener("DOMContentLoaded", function () {
  if (!window.halfContentBlocks || !Array.isArray(window.halfContentBlocks)) {
    return;
  }

  window.halfContentBlocks.forEach(function (block) {
    const section = document.getElementById(block.sectionId);
    if (!section) {
      console.warn("Section not found:", block.sectionId);
      return;
    }

    const colorDots = section.querySelectorAll(".color-dot");
    const imageDisplay = section.querySelector(".color-image-display");

    if (!colorDots.length) {
      console.warn("No color dots found in section:", block.sectionId);
      return;
    }

    if (!imageDisplay) {
      console.warn("No image display found in section:", block.sectionId);
      return;
    }

    // Add transition style to image
    imageDisplay.style.transition = "opacity 0.2s ease-in-out";

    colorDots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        // Remove active class from all dots
        colorDots.forEach(function (d) {
          d.classList.remove("active");
          d.style.borderColor = "#ccc";
        });

        // Add active class to clicked dot
        this.classList.add("active");
        this.style.borderColor = "#888888";

        // Get new image data
        const imageUrl = this.getAttribute("data-image-url");
        const imageAlt = this.getAttribute("data-image-alt");

        if (imageUrl) {
          // Fade out
          imageDisplay.style.opacity = "0";

          // Change image after fade out
          setTimeout(function () {
            imageDisplay.src = imageUrl;
            imageDisplay.alt = imageAlt;
            // Fade in
            imageDisplay.style.opacity = "1";
          }, 200);
        }
      });
    });
  });
});
